module.exports = __webpack_public_path__ + "fonts/icomoon.34e2f38c8c5e5df47e876cfc40659005.ttf";